import { Schema } from "effect";
import {
  ConversationId,
  ConversationThreadId,
  MessageId,
} from "../../ids/definitions";

export const AiReasoningNotification = Schema.Struct({
  _tag: Schema.Literal("aiReasoning"),
  conversationId: ConversationId,
  threadId: ConversationThreadId,
  text: Schema.String,
});
export type AiReasoningNotification = typeof AiReasoningNotification.Type;

export const AiToolCallNotification = Schema.Struct({
  _tag: Schema.Literal("aiToolCall"),
  conversationId: ConversationId,
  threadId: ConversationThreadId,
  toolName: Schema.String,
  toolCallId: Schema.String,
});
export type AiToolCallNotification = typeof AiToolCallNotification.Type;

export const AiTextDeltaNotification = Schema.Struct({
  _tag: Schema.Literal("aiTextDelta"),
  conversationId: ConversationId,
  threadId: ConversationThreadId,
  textDelta: Schema.String,
});
export type AiTextDeltaNotification = typeof AiTextDeltaNotification.Type;

export const AiStatusNotification = Schema.Struct({
  _tag: Schema.Literal("aiStatus"),
  conversationId: ConversationId,
  threadId: ConversationThreadId,
  status: Schema.String,
});
export type AiStatusNotification = typeof AiStatusNotification.Type;

export const AiMessageAddedNotification = Schema.Struct({
  _tag: Schema.Literal("aiMessageAdded"),
  conversationId: ConversationId,
  threadId: ConversationThreadId,
  messageId: MessageId,
  contentType: Schema.String,
});
export type AiMessageAddedNotification = typeof AiMessageAddedNotification.Type;

export const AiActivityNotification = Schema.Union(
  AiReasoningNotification,
  AiToolCallNotification,
  AiTextDeltaNotification,
  AiStatusNotification,
  AiMessageAddedNotification,
);
export type AiActivityNotification = typeof AiActivityNotification.Type;

export type AiActivityNotificationTag = AiActivityNotification["_tag"];
